import { render, staticRenderFns } from "./ContactIbanInfos.vue?vue&type=template&id=eb2e2986&scoped=true"
import script from "./ContactIbanInfos.vue?vue&type=script&lang=ts"
export * from "./ContactIbanInfos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2e2986",
  null
  
)

export default component.exports